const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}api/v1`;

console.log(BASE_URL);

export const ServiceApi = {

  MainPageApi: async (token) => {
    try {
      const url = `${BASE_URL}/jobs/?limit=5`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch main page jobs");
      return await response.json();
    } catch (err) {
      console.error("MainPageApi Error:", err);
      throw err;
    }
  },

  fetchjob: async (token, pageUrl = null) => {
    try {
      const url = pageUrl ? pageUrl : `${BASE_URL}/jobs/?limit=10&offset=0`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch jobs");
      return await response.json();
    } catch (err) {
      console.error("fetchJobs Error:", err);
      throw err;
    }
  },

  fetchRelatedJobs: async (token, title) => {
    try {
      if (!title) throw new Error("Title is required to fetch related jobs");
      const url = `${BASE_URL}/jobs/dashboard/?limit=10`;
      const body = { title };

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) throw new Error("Failed to fetch related jobs");
      return await response.json();
    } catch (err) {
      console.error("fetchRelatedJobs Error:", err);
      throw err;
    }
  },

  filterApi: async (token, body = {}, offset = 0, limit = 10) => {
    try {
      const url = `${BASE_URL}/jobs/dashboard/?limit=${limit}&offset=${offset}`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Failed to fetch filtered jobs: ${response.status} ${text}`);
      }
      return await response.json();
    } catch (err) {
      console.error("filterApi Error:", err);
      throw err;
    }
  },
  
  fetchCompany: async (token) => {
    try {
      const url = `${BASE_URL}/jobs/drop_down/`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch companies");
      return await response.json();
    } catch (err) {
      console.error("fetchCompany Error:", err);
      throw err;
    }
  },


  SavedApi: async (token, profileId, jobId, status = "saved") => {
    try {
      const url = `${BASE_URL}/userjobs/`;;
      const body = new URLSearchParams();
      body.append("job", jobId);
      body.append("profile", profileId);
      body.append("status", status);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: body,
      });
      const data = await response.json();

      if (!response.ok) {
        const errorMessage = data?.error?.message || "Failed to save job";
        throw new Error(errorMessage);
      }

      return data;
    } catch (err) {
      console.error("SavedApi Error:", err);
      throw err;
    }
  },

  UnsavedApi: async (token, status, userId) => {
    try {
      const url = `${BASE_URL}/userjobs/${userId}/`;
      const body = new URLSearchParams();
      body.append("status", status)

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          Authorization: `Token ${token}`,
        },
        body: body,
      });

      if (!response.ok) throw new Error("Failed to update job status");
      return await response.json();
    } catch (err) {
      console.error("UnsavedApi Error:", err);
      throw err;
    }
  },


  SavedGetApi: async (token, profileId, job_status, page, jobsPerPage) => {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}api/v1/userjobs/?profile_id=${profileId}&status=${job_status}&limit=${jobsPerPage}&offset=${(page - 1) * jobsPerPage}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch saved jobs");
      return await response.json();
    } catch (err) {
      console.error("SavedGetApi Error:", err);
      throw err;
    }
  },


   GetMyAllJobsApi: async (token, profileId, page = 1, jobsPerPage = 1) => {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}api/v1/userjobs/?profile_id=${profileId}&limit=${jobsPerPage}&offset=${(page - 1) * jobsPerPage}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch saved jobs");
      return await response.json();
    } catch (err) {
      console.error("SavedGetApi Error:", err);
      throw err;
    }
  },


  AppliedApi: async (token, profileId, jobId, status = "applied") => {
    try {
      const url = `${BASE_URL}/userjobs/`;;
      const body = new URLSearchParams();
      body.append("job", jobId);
      body.append("profile", profileId);
      body.append("status", status);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: body,
      });

      const data = await response.json();
      if (!response.ok) {
        const errorMessage = data?.error?.message || "Failed to apply to job";
        throw new Error(errorMessage);
      }
      return data;
    } catch (err) {
      console.error("AppliedApi Error:", err);
      throw err;
    }
  },

  JobViewApi: async (token, jobid) => {
    try {
      const url = `${BASE_URL}/jobs/${jobid}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json"
        },

      });

      if (!response.ok) throw new Error("Failed to job view");
      return await response.json();
    } catch (err) {
      console.error("JobViewApi Error:", err);
      throw err;
    }
  },


  MainPageApplyApi: async (token, jobId, resume, email, phone) => {
    try {
      const url = `${BASE_URL}/userjobs/`;;
      const body = new URLSearchParams();
      const formData = new FormData();
      formData.append("job", jobId);
      formData.append("resume", resume);
      formData.append("email", email);
      formData.append("phone", phone);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Token ${token}`,

        },
        body: formData,
      });

      const data = await response.json();
      if (!response.ok) {
        const errorMessage = data?.error?.message || "Failed to apply to job";
        throw new Error(errorMessage);
      }
      return data;
    } catch (err) {
      console.error("AppliedApi Error:", err);
      throw err;
    }
  },


  DeleteApi: async (token, jobId) => {
    try {
      const url = `${BASE_URL}/jobs/notInterested/`;

      const formData = new FormData();
      formData.append('job', jobId);

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Token ${token}`,
          'Cookie': `token=${token}`
        },
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server responded with status ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      return data;
    } catch (err) {
      console.error("DeleteAPi Error:", err);
      throw err;
    }
  },
   DiscardApi: async (token, userjobId) => {
    try {
      const url = `${BASE_URL}/userjobs/${userjobId}`;

      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Token ${token}`,
          'Cookie': `token=${token}`
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server responded with status ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      return data;
    } catch (err) {
      console.error("DeleteAPi Error:", err);
      throw err;
    }
  },

  FitForThisJob: async (token, jobId) => {
    try {
      const url = `${BASE_URL}/jobs/goodFit/`;

      const formData = new FormData();
      formData.append("job", jobId);

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Token ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to check job fit: ${response.status} ${errorText}`);
      }

      const data = await response.json();
      return data;
    } catch (err) {
      console.error("FitForThisJob Error:", err);
      throw err;
    }
  },

  TailorResume: async (token, jobId) => {
    try {
      const url = `${BASE_URL}/jobs/tailorResume/`;

      const formData = new FormData();
      formData.append("job", jobId);

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Token ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to tailor resume: ${response.status} ${errorText}`);
      }

      // ✅ Return blob URL instead of downloading directly
      const blob = await response.blob();
      const previewUrl = window.URL.createObjectURL(blob);
      return previewUrl;

    } catch (err) {
      console.error("TailorResume Error:", err);
      throw err;
    }
  },
}